import { useState } from 'react';
import { isVideoAsset } from '../utils/videoAsset';
import VideoPlayerModal from './VideoPlayerModal';

// Opens an asset. Documents and images open in a new tab; videos play in a
// popup, since a bare browser tab can't play every video format.
function AssetLink({ asset, children, className = '', onClick, ...rest }) {
    const [playing, setPlaying] = useState(false);

    if (!isVideoAsset(asset)) {
        return (
            <a href={asset.source} target='_blank' rel='noopener noreferrer' onClick={onClick} className={className} {...rest}>
                {children}
            </a>
        );
    }

    return (
        <>
            <button
                type='button'
                onClick={(e) => { onClick?.(e); setPlaying(true); }}
                className={`text-left ${className}`}
                {...rest}
            >
                {children}
            </button>
            {playing && <VideoPlayerModal asset={asset} onClose={() => setPlaying(false)} />}
        </>
    );
}

export default AssetLink;
